import { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { resetPassword } from '../../api/client';

export default function ResetPassword() {
  const { token } = useParams();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (password !== confirm) {
      setError('Passwords do not match');
      return;
    }
    setLoading(true);
    try {
      await resetPassword(token, password);
      setDone(true);
    } catch (err) {
      setError(err.message || 'Failed to reset password');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/bcd-icon.png" alt="BCD" className="h-10 mx-auto mb-3" />
          <h1 className="text-2xl font-heading font-bold text-white uppercase tracking-wide">
            Set New Password
          </h1>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8">
          {done ? (
            <div className="text-center">
              <p className="text-txt-primary mb-4">
                Your password has been reset.
              </p>
              <Link to="/login" className="btn-gold inline-block px-6 py-2 text-sm font-semibold">
                Log in
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
              <input
                type="password"
                placeholder="New password (12+ characters)"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-gold"
              />
              <input
                type="password"
                placeholder="Confirm new password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
                className="border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-gold"
              />
              {error && <p className="text-red-500 text-sm">{error}</p>}
              <p className="text-xs text-gray-500">
                12+ characters. Must include uppercase, lowercase, number, and special character.
              </p>
              <button
                type="submit"
                disabled={loading}
                className="btn-gold w-full py-3 text-sm font-semibold disabled:opacity-50"
              >
                {loading ? 'Resetting...' : 'Reset Password'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
